const StockBrokerSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-12">
              <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                <div className="about__content-inner">
                  <h4>Vision</h4>
                  <p className="text-justify">
                    To follow highest standards of ethics and compliances while facilitating the trading by clients in
                    securities in a fair and transparent manner, so as to contribute in creation of wealth for investors.
                  </p>
                  
                  <h4>Mission</h4>
                  <ul className="tab-list">
                    <li>To provide high quality and dependable service through innovation, capacity enhancement and use
                      of technology.</li>
                    <li>To establish and maintain a relationship of trust and ethics with the investors.</li>
                    <li>To observe highest standard of compliances and transparency.</li>
                    <li>To always keep 'protection of investors' interest' as goal while providing service.</li>
                    <li>To ensure confidentiality of information shared by investors unless such information is required
                      to be provided in furtherance of discharging legal obligations or investors have provided
                      specific consent to share such information.</li>
                  </ul>
                  
                  <h4>Services Provided to Investors by Stockbrokers</h4>
                  <ul className="tab-list">
                    <li>Execution of trades on behalf of investors.</li>
                    <li>Issuance of Contract Notes.</li>
                    <li>Issuance of intimations regarding margin due payments.</li>
                    <li>Facilitate execution of early pay-in obligation instructions.</li>
                    <li>Periodic Settlement of client's funds.</li>
                    <li>Issuance of retention statement of funds at the time of settlement.</li>
                    <li>Risk management systems to mitigate operational and market risk.</li>
                    <li>Facilitate client profile changes in the system as instructed by the client.</li>
                    <li>Information sharing with the client w.r.t. relevant Market Infrastructure Institutions (MII)
                      circulars.</li>
                    <li>Provide a copy of Rights &amp; Obligations document to the client.</li>
                    <li>Communicating Most Important Terms and Conditions (MITC) to the client.</li>
                    <li>Redressal of Investor's grievances.</li>
                  </ul>
                  
                  <h4>Rights of Investors</h4>
                  <ul className="tab-list">
                    <li><strong>Ask for and receive information</strong> from a firm about the work history and
                      background of the person handling your account, as well as information about the firm itself.
                    </li>
                    <li><strong>Receive complete information</strong> about the risks, obligations, and costs of any
                      investment before investing.</li>
                    <li><strong>Receive a copy</strong> of all completed account forms and rights &amp; obligation
                      document.
                    </li>
                    <li><strong>Receive a copy</strong> of 'Most Important Terms &amp; Conditions' (MITC).</li>
                    <li><strong>Receive account statements</strong> that are accurate and understandable.</li>
                    <li><strong>Understand the terms</strong> and conditions of transactions you undertake.</li>
                    <li><strong>Access your funds</strong> in a prescribed manner and be informed about any
                      restrictions.</li>
                    <li><strong>Receive complete information</strong> about fees and penalties in the form of a tariff
                      sheet.</li>
                    <li><strong>Discuss grievances</strong> with the compliance team and receive prompt and fair
                      responses.</li>
                    <li><strong>Close zero balance accounts</strong> online with minimal documentation.</li>
                    <li><strong>Receive all policies</strong> including MITC related to your account dealings.</li>
                    <li><strong>Be treated fairly</strong> and equally as other clients.</li>
                    <li><strong>Receive only compliant</strong> advertisement materials.</li>
                    <li><strong>Be compensated</strong> via the Investor Protection Fund in case of broker default (as
                      per norms).</li>
                    <li><strong>Trade in derivatives</strong> upon submission of financial documents and due diligence.
                    </li>
                    <li><strong>Get warnings</strong> while trading securities under surveillance.</li>
                    <li><strong>Access services</strong> even if differently abled.</li>
                    <li><strong>Access investor education</strong> materials from MIIs and brokers.</li>
                    <li><strong>Access all exchanges</strong> within a segment unless opted out.</li>
                    <li><strong>Choose one or more stockbrokers</strong> without being forced to commit minimum
                      business.</li>
                    <li><strong>Use an escalation matrix</strong> to contact the broker.</li>
                    <li><strong>Not be subject</strong> to any unlawful or unfair broker-imposed clauses.</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="contact-us mt-2">
              <h4>Details of Grievance Redressal Mechanism</h4>
              <p>Various activities of Stock Brokers with timelines</p>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr className="gray">
                      <th scope="col">S.No.</th>
                      <th scope="col">Activities</th>
                      <th scope="col">Expected Timelines</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>KYC entered into KRA System and CKYCR</td>
                      <td>3 working days of account opening</td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">2</th>
                      <td>Client Onboarding</td>
                      <td>Immediate, but not later than one week</td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Order execution</td>
                      <td>Immediate on receipt of order, but not later than the same day</td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">4</th>
                      <td>Allocation of Unique Client Code</td>
                      <td>Before trading</td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td>Copy of duly completed Client Registration Documents to clients</td>
                      <td>7 days from the date of upload of Unique Client Code to the Exchange by the trading member
                      </td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">6</th>
                      <td>Issuance of contract notes</td>
                      <td>24 hours of execution of trades</td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td>Collection of upfront margin from client</td>
                      <td>Before initiation of trade</td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">8</th>
                      <td>Issuance of intimations regarding other margin due payments</td>
                      <td>At the end of the T day</td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td>Settlement of client funds</td>
                      <td>30 days / 90 days for running account Settlement (RAS) as per the preference of client. If
                        consent not given for RAS - within 24 hours of pay-out</td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">10</th>
                      <td>'Statement of Accounts' for Funds, Securities and Commodities</td>
                      <td>Weekly basis</td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td>Issuance of retention statement of funds/commodities</td>
                      <td>5 days from the date of settlement</td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">12</th>
                      <td>Issuance of Annual Global Statement</td>
                      <td>30 days from the end of the financial year</td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td>Investor grievances redressal</td>
                      <td>21 calendar days from the receipt of the complaint</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="contact-us mt-2">
              <h4>Dos and DON'Ts for Investors</h4>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr className="gray">
                      <th scope="col">S.No.</th>
                      <th scope="col">Dos</th>
                      <th scope="col">DON'Ts</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Read all documents and conditions being agreed before signing the account opening form.</td>
                      <td>Do not deal with unregistered stock broker.</td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">2</th>
                      <td>Receive a copy of KYC, copy of account opening documents and Unique Client Code.</td>
                      <td>Do not forget to strike off blanks in your account opening and KYC.</td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Read the product / operational framework / timelines related to various Trading and Clearing
                        &amp; Settlement processes.</td>
                      <td>Do not submit an incomplete account opening and KYC form.</td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">4</th>
                      <td>Receive all information about brokerage, fees and other charges levied.</td>
                      <td>Do not forget to inform any change in information linked to trading account and obtain
                        confirmation of updation in the system.</td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td>Register your mobile number and email ID in your trading, demat and bank accounts to get regular
                        alerts on your transactions.</td>
                      <td>Do not transfer funds, for the purposes of trading to anyone other than a stock broker. No
                        payment should be made in name of employee of stock broker.</td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">6</th>
                      <td>If executed, receive a copy of Demat Debit and Pledge Instruction (DDPI). However, DDPI is not a
                        mandatory requirement as per SEBI / Stock Exchanges. Before granting DDPI, carefully examine the
                        scope and implications of powers being granted.</td>
                      <td>Do not ignore any emails / SMSs received with regards to trades done, from the Stock Exchange
                        and raise a concern, if discrepancy is observed.</td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td>Receive contract notes for trades executed, showing transaction price, brokerage, GST and
                        STT/CTT etc. as applicable, separately, within 24 hours of execution of trades.</td>
                      <td>Do not opt for digital contracts, if not familiar with computers.</td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">8</th>
                      <td>Receive funds and securities/commodities on time, as prescribed by SEBI or exchange from time to
                        time.</td>
                      <td>Do not share trading password.</td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td>Verify details of trades, contract notes and statement of account and approach relevant
                        authority for any discrepancies. Verify trade details on the Exchange websites from the trade
                        verification facility provided by the Exchanges.</td>
                      <td>Do not fall prey to fixed / guaranteed returns schemes.</td>
                    </tr>
                    <tr className="gray">
                      <th scope="row">10</th>
                      <td>Receive statement of accounts periodically. If opted for running account settlement, account has
                        to be settled by the stock broker as per the option given by the client (Monthly or Quarterly).
                      </td>
                      <td>Do not fall prey to fraudsters sending emails and SMSs luring to trade in stocks / securities
                        promising huge profits.</td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td>In case of any grievances, approach stock broker or Stock Exchange or SEBI for getting the same
                        resolved within prescribed timelines.</td>
                      <td>Do not follow herd mentality for investments. Seek expert and professional advice for your
                        investments.</td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td>Retain documents for trading activity as it helps in resolving disputes, if they arise.</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <p>Additionally, Investors may refer to Dos and Don'ts issued by MIIs on their respective websites
                  from time to time.</p>
              </div>
            </div>

            <div className="contact-us mt-2">
              <h4>Grievance Redressal Mechanism</h4>
              <p>The process of investor grievance redressal is as follows:</p>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{width: '50px'}}>Sr.No.</th>
                      <th>Process</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Investor Complaint / Grievance</td>
                      <td>
                        Investor can lodge complaint/grievance against a stock broker via:
                        <ul>
                          <li><strong>With Stock Broker:</strong> Email to designated Investor Grievance
                            ID of the broker. (Refer website under "Investor Grievance" tab)</li>
                          <li><strong>With Stock Exchanges:</strong>
                            <ul>
                              <li><a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer">SCORES 2.0</a>
                                (SEBI's web-based grievance redressal system)</li>
                              <li>Email to designated Exchange grievance IDs</li>
                              <li>Two-level review:
                                <ul>
                                  <li>1st by Designated Body / Exchange</li>
                                  <li>2nd by SEBI</li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Online Dispute Resolution (ODR)</td>
                      <td>
                        If dissatisfied with the broker's resolution, the investor may file a complaint on
                        the <strong>SMARTODR</strong> platform for:
                        <ul>
                          <li>Online conciliation</li>
                          <li>Online arbitration</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Steps in ODR Process</td>
                      <td>
                        <ul>
                          <li>Approach Market Participant first</li>
                          <li>If not resolved, choose one:
                            <ul>
                              <li>Escalate via <a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer">SEBI SCORES</a></li>
                              <li>File complaint on SMARTODR</li>
                            </ul>
                          </li>
                          <li>Upon complaint on SMARTODR, MII reviews &amp; resolves in 21 days</li>
                          <li>If unresolved, matter proceeds to <strong>conciliation</strong> (21 days +
                            10 days with consent)</li>
                          <li>If still unresolved, matter proceeds to <strong>arbitration</strong> (30
                            days + 30 days with consent)</li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <div className="contact-us mt-2">
              <h4>Handling of Investor's Claims / Complaints in Case of Default of a Trading Member / Clearing Member
                (TM/CM)</h4>
              <p><b>Default of TM/CM: </b>Following steps are carried out by the Stock Exchange for the benefit of
                investors in case a stock broker defaults:</p>
              <ul className="tab-list">
                <li>Circular is issued to inform about declaration of Stock Broker as Defaulter.</li>
                <li>Public Notice is issued informing declaration of a stock broker as defaulter and inviting
                  claims within specified period.</li>
                <li>Intimation to clients of defaulter stock brokers via emails and SMS for facilitating lodging
                  of claims within the specified period.</li>
              </ul>
              <p><b>Following information is available on the Stock Exchange website for investors:</b></p>
              <ul className="tab-list">
                <li>Norms for eligibility of claims for compensation from IPF.</li>
                <li>Claim form for lodging claim against defaulter stock broker.</li>
                <li>FAQ on processing of investors' claims against Defaulter stock broker.</li>
                <li>Provision to check online status of client's claim.</li>
                <li>Standard Operating Procedure (SOP) for handling of Claims of Investors in the Cases of
                  Default by Brokers.</li>
                <li>Claim processing policy against Defaulter/Expelled members.</li>
                <li>List of Defaulter/Expelled members and public notice issued.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StockBrokerSection;